import { SEAT_CIRCLE_DIAMETER, SEAT_CIRCLE_RADIUS, ROW_SPACING } from '../../constants';
import { round } from '../../utils/utils';
import { createLabelGenerator } from '../../utils/label-generator';
import { getPlaceElementId } from '../../utils/place';
export const getRowCurveRadius = (rowIndex, definition, firstRowRadius) => {
    const offsetIndex = definition.rows.length - rowIndex - 1;
    const diff = offsetIndex * (SEAT_CIRCLE_DIAMETER + definition.spacingBetweenRows);
    const radius = firstRowRadius + diff;
    return radius;
};
export const getCurvedRow = ({ definition, row, rowIndex, rowLabelGenerator, rowPlaceMap = {}, }) => {
    const { width, seatAmount, spacingBetweenRows: rowSpacing = ROW_SPACING, curveAngleFrom, curveAngleTo, labelPosition, reverseDirection, sectorLabel, sequence, startAt, shapeBorderColor, shapeColor, shapeTextColor, categoryId, } = definition;
    const capacity = row.overrides.seatAmount ?? seatAmount;
    const defaultRowLabel = rowLabelGenerator ? rowLabelGenerator.getLabelByIndex(rowIndex) : '';
    const verticalReservedSeatSpace = rowSpacing + SEAT_CIRCLE_DIAMETER;
    const firstRowCurveRadius = definition.curveRadius + SEAT_CIRCLE_RADIUS;
    const midX = round(width / 2);
    const midY = rowIndex * verticalReservedSeatSpace + SEAT_CIRCLE_RADIUS;
    const curveRadius = getRowCurveRadius(rowIndex, definition, firstRowCurveRadius);
    const rowDefinition = {
        id: row.id,
        midX,
        midY,
        capacity,
        curveAngleFrom: row.overrides.curveAngleFrom ?? curveAngleFrom,
        curveAngleTo: row.overrides.curveAngleTo ?? curveAngleTo,
        curveRadius,
        label: row.overrides?.label ?? defaultRowLabel,
        labelPosition: row.overrides?.labelPosition ?? labelPosition,
        reverseDirection: row.overrides?.reverseDirection ?? reverseDirection,
        seatAmount: row.overrides?.seatAmount ?? seatAmount,
        sectorLabel,
        sequence: row.overrides?.sequence ?? sequence,
        startAt: row.overrides?.startAt ?? startAt,
        placeOverrides: row.placeOverrides ?? [],
        places: rowPlaceMap[row.id] ?? [],
        shapeBorderColor: row.shapeBorderColor ?? shapeBorderColor,
        shapeColor: row.shapeColor ?? shapeColor,
        shapeTextColor: row.shapeTextColor ?? shapeTextColor,
        categoryId,
    };
    return rowDefinition;
};
export const getCurvedRows = ({ definition }) => {
    const { rows: rowOverrides, rowsSequence, rowsStartAt, rowsReverseDirection } = definition;
    const rowsAmount = rowOverrides.length;
    const rows = [];
    const rowLabelGenerator = createLabelGenerator({
        sequence: rowsSequence,
        startAt: rowsStartAt,
        reverseDirection: rowsReverseDirection,
        capacity: rowsAmount,
    });
    const rowPlaceMap = {};
    for (const place of definition.places ?? []) {
        const shapeId = getPlaceElementId(place);
        rowPlaceMap[shapeId] = rowPlaceMap[shapeId] ?? [];
        rowPlaceMap[shapeId].push(place);
    }
    definition.rows.forEach((row, rowIndex) => {
        const rowDefinition = getCurvedRow({ definition, row, rowIndex, rowLabelGenerator, rowPlaceMap });
        rows.push(rowDefinition);
    });
    return rows;
};
//# sourceMappingURL=utils.js.map